let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jJS8Y")).then(() => parcelRequire('a6kDH'));